// src/StatusTable.js
import React, { useState, useEffect } from "react";
import "./StatusTable.css";
import { ArrowUpRight, ArrowDownRight, Maximize2 } from "lucide-react";

function renderLink(url) {
  let domain;
  try {
    domain = new URL(url).hostname.replace(/^www\./, "");
  } catch {
    domain = url;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="source-link"
    >
      <span className="source-symbol">⍈</span>
      <span className="source-domain">{domain}</span>
    </a>
  );
}

export default function StatusTable({ rows, showSector, showCountry }) {
  const [openIdx, setOpenIdx] = useState(null);

  // Close the source popout when clicking outside of any action container
  useEffect(() => {
    if (openIdx === null) return;
    const handleClick = e => {
      if (!e.target.closest(".action-container")) {
        setOpenIdx(null);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [openIdx]);

  return (
    <div className="status-table-wrapper">
    <table className="status-table">
      <thead>
        <tr>
          <th className="company-col">Company</th>
          <th className="ticker-col">Ticker</th>
          {showCountry && <th>Country</th>}
          {showSector && <th>Sector</th>}
          <th className="status-col">Status</th>
          <th className="action-col">Action (Click the action to view sources)</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => {
          const status = (r.monthly_status || "no_data").toLowerCase();
          const label =
            status === "no_data"
              ? "No Recent Data"
              : status.charAt(0).toUpperCase() + status.slice(1);
          const open = openIdx === i;

          return (
            <tr key={i}>
              <td className="company-col">{r.company}</td>
              <td className="ticker-col">{r.ticker}</td>
              {showCountry && <td>{r.country}</td>}
              {showSector && <td>{r.sector}</td>}

              {/* STATUS CELL */}
              <td className="status-cell status-col">
                <span className={`status-badge ${status}`}>
                  {label}
                  {status === "investing" && (
                    <ArrowUpRight className="status-icon" size={10} />
                  )}
                  {status === "withdrawing" && (
                    <ArrowDownRight className="status-icon" size={10} />
                  )}
                </span>
              </td>

              {/* ACTION CELL WITH POPUP */}
              <td className="action-cell">
                {r.sources && r.sources.length > 0 ? (
                  <div className={`action-container ${status}${open ? " open" : ""}`}>
                    <button
                      className={`action-toggle${open ? " open" : ""}`}
                      onClick={() => setOpenIdx(open ? null : i)}
                    >
                      <span className="action-text">{r.action || "—"}</span>{"\u00A0"}
                      <Maximize2 className="action-open-icon" size={13} />
                    </button>
                    {open && (
                      <div className="statement-box">
                        <div className="statement-text">
                          {r.sources.length > 1 ? "Sources" : "Source"}
                        </div>
                        <div className="statement-sources">
                          {r.sources.map((s, idx) => (
                            <React.Fragment key={idx}>
                              {renderLink(s)}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    {r.action || "—"}
                  </>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <div className="table-bottom-bar"></div>
    </div>
  );
}
